import Loading from '../../../../Dashboards/Common/Loading';
import { Indicators } from './Indicators';
import { PeopleStratificationComparison } from './PeopleStratificationComparison';
import { PeopleStratificationPercentage } from './PeopleStratificationPercentage';
import { usePeopleChartsDataContext } from './hooks/usePeopleChartsDataContext';

export const Charts = () => {
    const { isLoading } = usePeopleChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <Indicators />
            <div className="charts-side-by-side-dashboards">
                <PeopleStratificationComparison />

                <PeopleStratificationPercentage />
            </div>
        </>
    );
};
